<div class="alle-auth-spinner-content">
  <img class="alle-auth-logo"src="https://allematerialstorage.blob.core.windows.net/logos/Horizontal/Horizontal%20PNG/Color%20Horizontal%20PNG.png">
  <svg class="alle-auth-spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
    <circle class="alle-auth-spinner-path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
  </svg>
</div>
  